import { Link } from "react-router-dom";
import Logo from "./Logo";
import { CONTACT_EMAIL } from "../config";
import { scrollToHash } from "../lib/scroll";

export default function Footer() {
  const links = [
    { label: "Work", to: "/demos", hash: false },
    { label: "Process", to: "/#process", hash: true },
    { label: "About", to: "/#about", hash: true },
    { label: "FAQ", to: "/#faq", hash: true },
    { label: "Request a quote", to: "/#contact", hash: true },
  ];
  return (
    <footer className="border-t border-line" data-testid="site-footer">
      <div className="container-cr flex flex-col gap-10 py-14 md:flex-row md:items-start md:justify-between">
        <div className="max-w-sm">
          <Logo />
          <p className="mt-4 text-sm text-dim">
            Websites for landscaping and hardscaping companies.
          </p>
        </div>
        <nav className="flex flex-col gap-3 text-sm" aria-label="Footer">
          {links.map((l) =>
            l.hash ? (
              <a
                key={l.label}
                href={l.to}
                onClick={(e) => {
                  e.preventDefault();
                  if (window.location.pathname !== "/") {
                    window.location.href = l.to;
                  } else {
                    scrollToHash(l.to.slice(1));
                  }
                }}
                className="text-dim transition-colors hover:text-cream"
              >
                {l.label}
              </a>
            ) : (
              <Link key={l.label} to={l.to} className="text-dim transition-colors hover:text-cream">
                {l.label}
              </Link>
            )
          )}
        </nav>
        <div className="flex flex-col gap-3 text-sm">
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-dim transition-colors hover:text-accent"
            data-testid="footer-email"
          >
            {CONTACT_EMAIL}
          </a>
          <p className="text-dim">
            &copy; {new Date().getFullYear()} Clearriver Studios. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
